import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteClient } from "../../api/apiClients";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف عميل (soft delete)
 */
export function useDeleteClient() {
    const queryClient = useQueryClient();

    const {
        mutate: deleteClientMutate,
        isPending,
    } = useMutation({
        mutationFn: deleteClient,
        onSuccess: (response) => {
            toast.success(response.message || "Deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["clients"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to delete client");
        },
    });

    return {
        deleteClientMutate,
        isPending,
    };
}